import { PostSection } from "@/components/blog/PostSection";
import { PostHighlight } from "@/components/blog/PostHighlight";

export function AppleIos27Section() {
  return (
    <PostSection id="apple-ios27" title="Apple abre iOS 27 a Claude y Gemini">
      <p>
        El 6 de mayo de 2026, Apple confirmó uno de los giros estratégicos más comentados del año:
        <strong> iOS 27 permitirá elegir entre Gemini de Google y Claude de Anthropic </strong>
        para ejecutar funciones de Apple Intelligence en el iPhone, además del modelo propio y
        ChatGPT, ya integrado desde iOS 18. Es la primera vez que la compañía abre su ecosistema
        a múltiples proveedores de IA conversacional como ciudadanos de primera clase.
      </p>

      <PostHighlight type="tip">
        El usuario podrá decidir qué modelo gestiona Siri, los resúmenes de notificaciones o las
        herramientas de escritura, sin necesidad de instalar apps de terceros.
      </PostHighlight>

      <h3 id="como-funciona-ios27" className="text-xl font-bold text-white mt-8 mb-4">
        Cómo funciona la elección de modelo
      </h3>
      <p>
        Desde Ajustes &gt; Apple Intelligence, el usuario podrá fijar un modelo por defecto y
        anular esa elección puntualmente para tareas concretas (por ejemplo, usar Claude para
        redactar correos largos y Gemini para búsquedas factuales). Apple actúa como
        <strong> orquestador neutral</strong>: enruta la petición al proveedor elegido manteniendo
        el cifrado y, cuando es posible, el procesamiento en el dispositivo gracias a Private Cloud Compute.
      </p>

      <h3 id="impacto-apple" className="text-xl font-bold text-white mt-8 mb-4">
        Impacto en el ecosistema Apple
      </h3>
      <ul className="list-disc pl-6 space-y-2 mt-4">
        <li><strong>Para usuarios:</strong> libertad real de elección sin tener que abandonar el ecosistema iOS.</li>
        <li><strong>Para Anthropic y Google:</strong> distribución masiva instantánea sobre cientos de millones de iPhones.</li>
        <li><strong>Para desarrolladores:</strong> nuevas APIs para invocar el modelo seleccionado sin gestionar credenciales.</li>
        <li><strong>Para Apple:</strong> posicionarse como capa de privacidad y orquestación, no como proveedor de IA puro.</li>
      </ul>
    </PostSection>
  );
}
